import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=b4352dba&scoped=true"
import script from "./AccountEdit.vue?vue&type=script&lang=js"
export * from "./AccountEdit.vue?vue&type=script&lang=js"
import style0 from "./AccountEdit.vue?vue&type=style&index=0&id=b4352dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4352dba",
  null
  
)

export default component.exports